/*eslint perfectionist/sort-objects: "error"*/

export const enGb = {
  account: "Account",
  accountHolderName: "Account holder name",
  accountId: "Account ID",
  accountNumber: "Account number",
  aliasAccountNumber: "Alias account number",
  aliasIban: "Alias IBAN",
  aliasSortCode: "Alias sort code",
  aliasSwiftCodeBic: "Alias swift code (BIC)",
  amount: "Amount",
  amountDisabledBlocked:
    "Amount can't be set - this payment can't be refunded right now.",
  amountDisabledError:
    "Amount can't be set - couldn't check refund eligibility.",
  amountDisabledFullyRefunded:
    "Amount can't be set - no balance available to refund.",
  amountDisabledFundsReturned:
    "Amount can't be set - funds have already been returned.",
  amountDisabledRefundInProgress:
    "Amount can't be set - a refund is already in progress.",
  amountDisabledReturnInProgress:
    "Amount can't be set - this payment is being returned.",
  amountDisabledReversalInProgress:
    "Amount can't be set - this payment is being reversed.",
  amountDisabledWindowClosed:
    "Amount can't be set - time for refund has expired.",
  amountRefundedAlready: "Amount refunded already",
  approve: "Approve",
  approved: "Approved",
  approvingTransaction: "Approving transaction",
  areYouSureYouWantToRejectThisPayment:
    "Are you sure you want to reject this payment?",
  availableToRefund: "Available to refund",
  availableToRefundAmount: "Available to refund: {{amount}}.",
  availableToRefundFetchError: "Couldn't check refund eligibility.",
  backToAllPayments: "Back to all payments",
  beneficiary: "Beneficiary",
  bounceBack: "Bounce back",
  choosingPayment: "Choosing payment",
  closedLoopPayout: "Payout — closed loop",
  closedLoopPayoutDescription:
    "Send funds to a customer who paid in the last 12 months",
  comingSoon: "Coming soon",
  completed: "Completed",
  country: "Country",
  created: "Created",
  createdBy: "Created by",
  createdByName: "Created by {{name}}",
  createdByScheduler: "Created by scheduler",
  createdViaApi: "Created via API",
  createPayment: "Create payment",
  createPaymentFailure: "We couldn't create this payment. Please try again.",
  createRefund: "Create refund",
  createRefundConfirmationApprovalRequired:
    "The refund must be approved before it is sent. Approval will become available once Volt receives the Account Holder Verification result.",
  createRefundConfirmationFundsNotSent:
    "Creating this refund will not send the funds.",
  createRefundRequest: "Create refund request",
  credit: "Credit",
  details: "Details",
  findPaymentToRefund: "Find a payment that you want to refund.",
  gatewayPayment: "Gateway payment",
  givenSourceAccountCouldNotBeFound:
    "The account you're trying to use could not be found.",
  iban: "IBAN",
  ibanOrAccountNumber: "IBAN / Acc no.",
  incoming: "Incoming",
  internal: "Internal",
  internalFx: "Internal FX",
  internalFxDescription: "Internal transfer with currency conversion",
  internalReference: "Internal reference",
  internalTransfer: "Internal transfer",
  internalTransferDescription: "Transfer funds between accounts within Volt",
  local: "Local",
  name: "Name",
  newPayment: "New payment",
  noPayments: "No payments",
  noSourceAccountFoundByIdentifier:
    "No account found with this IBAN or account number. Make sure it's complete and correct.",
  noSourceAccountsFound: "No accounts found.",
  openLoopPayout: "Payout — open loop",
  openLoopPayoutDescription: "Make a one-time transfer to a new beneficiary",
  outgoing: "Outgoing",
  own: "Own",
  owner: "Owner",
  payment: "Payment",
  paymentAmount: "Payment amount",
  paymentHasBeenApproved: "Payment has been approved",
  paymentHasBeenRejected: "Payment has been rejected",
  paymentRail: "Payment rail",
  paymentReference: "Payment reference",
  payments: "Payments",
  paymentType: "Payment type",
  paymentTypeDescription: "Pick what you want to do with this account.",
  paymentTypesFetchError: "Couldn't load payment types for this account.",
  paymentTypesNoPermission:
    "You don't have permission to make payments from this account.",
  paymentTypesNotEnabled: "This account isn't enabled for any payment type.",
  payout: "Payout",
  processing: "Processing",
  reference: "Reference",
  refund: "Refund",
  refundAlreadyInProgress: "A refund is already in progress for this payment.",
  refundBlockedFundsAlreadyReturned: "Funds already returned",
  refundBlockedNothingLeftToRefund: "Payment fully refunded",
  refundBlockedRefundInProgress: "Refund in progress",
  refundBlockedRefundPeriodExpired: "Refund period expired",
  refundBlockedReturnInProgress: "Return in progress",
  refundBlockedReversalInProgress: "Reversal in progress",
  refundBlockedTransactionNotEligible: "Refund not available",
  refundDescription: "Refund an existing payment",
  refundDueDate: "Refund due date",
  refundFullyRefunded: "This payment has already been fully refunded.",
  refundFundsReturned: "The funds for this payment have already been returned.",
  refundNotEligible: "This payment isn't eligible for a refund.",
  refundReturnInProgress: "This payment is being returned.",
  refundReversalInProgress: "This payment is being reversed.",
  refundsRequested: "Refunds requested",
  refundWindowClosed: "The refund window for this payment closed on {{date}}.",
  reject: "Reject",
  rejected: "Rejected",
  rejectingPayment: "Rejecting payment",
  scaRequiredToApproveThisPayment:
    "You need to set up strong customer authentication (SCA) to approve this payment",
  sender: "Sender",
  sepaInstant: "SEPA Instant",
  setMaxAmount: "Set max amount",
  settlement: "Settlement",
  settlementDescription: "Settle funds to a trusted beneficiary",
  sortCode: "Sort code",
  source: "Source",
  sourceAccount: "Source account",
  sourceAccountDescription:
    "Search by name or paste an exact IBAN / account number.",
  sourceAccountNotFound: "Account not found",
  sourceAccountPlaceholder: "Select account",
  sourceAccountsLoadError: "Couldn't load accounts. Try again.",
  sourcePaymentNotFound: "Payment not found",
  status: "Status",
  swiftCodeBic: "Swift code (BIC)",
  topUp: "Top-up",
  type: "Type",
  uniqueReference: "Unique reference",
  unknownUser: "User",
  voltId: "Volt ID",
  voltIsVerifyingPayeeDetails:
    "Volt is verifying payee details. Approval will be available once verification is complete.",
  voltPaymentId: "Volt payment ID",
  youCannotPerformThisOperation: "You cannot perform this operation",
  youDontHaveAnyPaymentsThatMatchTheCriteria:
    "You don't have any payments that match the criteria.",
  youDontHaveAnyPaymentsYet: "You don't have any payments yet.",
};
